import { cn } from '@/utils/cn';
import { type VariantProps, cva } from 'class-variance-authority';
import type React from 'react';
import SectionTitle from './atoms/SectionTitle';

const sectionVariants = cva('relative font-neue-haas mx-2 md:mx-4 lg:mx-8', {
    variants: {
        variant: {
            content: 'py-8 px-4 sm:px-8', // Text content that needs reading space
            collection: 'py-8', // Collections that only need rhythm
            custom: 'p-0', // Custom layouts handle own spacing
            nested: 'mx-0 md:mx-0 lg:mx-0 p-0', // No margin, for use inside WrapperWithSidebars
        },
        layout: {
            default: '',
            withTitle: 'flex flex-wrap sm:flex-nowrap',
        },
        background: {
            none: '',
            'haug-ivory-100': 'bg-haug-ivory-100',
            'haug-choco-100': 'bg-haug-choco-100',
        },
    },
    defaultVariants: {
        variant: 'content',
        background: 'none',
    },
});

interface SectionProps extends VariantProps<typeof sectionVariants> {
    title?: string;
    children: React.ReactNode;
}

export default function Section({ title, variant, background, children }: SectionProps) {
    return (
        <div
            className={cn(
                sectionVariants({
                    variant,
                    layout: title ? 'withTitle' : 'default',
                    background,
                })
            )}
        >
            {title && <SectionTitle>{title}</SectionTitle>}
            {children}
        </div>
    );
}
